<template>
  <!-- 头部整体盒子 -->
  <div id="header" class="container-fuild">
    <!-- 电脑导航 -->
    <div class="header-nav container hidden-xs"  >
      <!-- 导航logo -->
      <div class="header-nav-logo wow zoomIn">
        <img src="@/assets/img/header/logo.png">
      </div>
      <!-- 导航内容 -->
      <ul class="header-nav-wrapper">
        <li
          v-for="(item,index) in navList"
          :key="index"
          :class="index==navIndex?'active':''"
          @click="navClick(index,item.name)"
        >
          <router-link :to="item.path">
            {{item.name}}
<!--            <span v-if="item.children.length>0" class="glyphicon glyphicon-menu-down"></span>-->
<!--            <i class="underline"></i>-->
          </router-link>
        </li>
      </ul>
      <div class="header-nav-wrapper-right wow zoomInRight">
        <p style="margin: 0">品牌热线：010-57170383</p>
        <img class="wximg" src="@/assets/img/header/wx.png">
        <div class="wxcontent  "  >
          <img :src="contactInfo.img">
        </div>
      </div>
    </div>
    <!-- 手机导航 -->
    <div class="header-nav-m container-fuild visible-xs">
<!--      <div class="header-nav-m-logo">-->
<!--       -->
<!--      </div>-->
      <!-- 导航栏 -->
      <div class="header-nav-m-menu text-center">
        <div
          class="header-nav-m-menu-wrapper"
          data-toggle="collapse"
          data-target="#menu"
          @click="menuClick"
        >
          <span :class="menuClass"></span>
        </div>

        <img class="wow zoomIn" style="height: 80%; margin-left: 40px;" src="@/assets/img/header/logo.png" alt="logo">
<!--        <img class="wow zoomIn" style="height: 80%; margin-left: 55px;" src="@/assets/img/form/top5.png" alt="logo">-->
        <img class="wow zoomIn wxtop-m " @click="showwx = !showwx" style="height: 25px; position: fixed;top: 12px;right: 10px;cursor: pointer" src="@/assets/img/header/wx.png">


<!--        {{menuName}}-->
        <!-- 导航内容 -->
        <ul id="menu" class="header-nav-m-wrapper collapse">
          <li
            v-for="(item,index) in navList"
            :key="index"
            :class="index==navIndex?'active':''"
            @click="navClick(index,item.name)"
            data-toggle="collapse"
            data-target="#menu"
          >
            <router-link :to="item.path">
              {{item.name}}
              <i class="underline"></i>
            </router-link>
          </li>
<!--          <li style="    position: fixed;-->
<!--    bottom: 0px;-->
<!--    width: 50%;-->
<!--    font-size: 14px;-->
<!--    left: 0;">加盟热线：222-2222-111</li>-->
        </ul>
      </div>
    </div>
    <div  >
      <div class="wxcontent-m"  v-show="showwx" >
        <img :src="contactInfo.img">
      </div>
    </div>
  </div>
</template>
<script>
import {contactlatest} from "../api";

export default {
  name: "Header",
  props:{
    imgUrl: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      showwx:false,
      contactInfo:{},
      navIndex: sessionStorage.getItem('navIndex') ? sessionStorage.getItem('navIndex') : 0,
      menuName: "首页",
      menuClass: "glyphicon glyphicon-menu-down",
      navList: [
        {
          name: "首    页",
          path: "/",
          children: []
        },
        {
          name: "品牌介绍",
          path: "/brand",
          children: []
        },
        {
          name: "产品介绍",
          path: "/product",
          children: []
        },
        {
          name: "门店分布",
          path: "/atore",
        },
        // {
        //   name: "品质加盟",
        //   path: "/newsinformation",
        //   children: []
        // },
        // {
        //   name: "品质加盟",
        //   path: "/joinus",
        //   children: []
        // },
        {
          name: "关于我们",
          path: "/aboutus",
          children: []
        }
      ]
    };
  },
  created() {
    this.getContact()
  },
  mounted() {
    this.onWindowsScroll()
  },
  methods: {
    getContact(){
      let contactStr = sessionStorage.getItem('contactinfo')
      if(contactStr && contactStr != undefined && contactStr!=null && contactStr !='undefined' && contactStr !='null' ){
        let contactInfoStor = JSON.parse(contactStr)
        this.contactInfo = contactInfoStor
      } else {
        contactlatest().then(res => {
          if(res.code == '200'){
            this.contactInfo = res.data
            sessionStorage.setItem('contactinfo',JSON.stringify(this.contactInfo))
          }
        }).catch(error => {
        })
      }
    },
    onWindowsScroll(){
      window.onscroll = function(){
        var Yheight = document.body.scrollTop || document.documentElement.scrollTop;
        var h = 598;
        var opacity = 0;
        if(Yheight > h){
          opacity = 1;
        } else{
          opacity = Yheight/h*1 +0.15;
        }
        $('#header').css('backgroundColor','rgba(0,0,0,'+ opacity +')');
      }
    },
    navClick(index, name) {
      this.navIndex = index;
      sessionStorage.setItem('navIndex',index)
      this.menuName = name;
    },
    menuClick() {
      if (this.menuClass == "glyphicon glyphicon-menu-down") {
        this.menuClass = "glyphicon glyphicon-menu-up";
      } else {
        this.menuClass = "glyphicon glyphicon-menu-down";
      }
    }
  }
};
</script>
<style scoped>
/* 顶部 */
#header {
  background: rgba(0,0,0,0.15);
  transition: all ease 0.6s;
  position: fixed;
  top: 0;
  z-index: 9999;
  width: 100%;
}
#header .header-top {
  height: 50px;
  color: #fff;
  font-size: 12px;
  line-height: 50px;
  background: #474747;
}
/* 顶部的图标 */
#header .header-top span {
  margin: 0 8px;
}
/* 导航栏 */
#header .header-nav {
  height: 90px;
}
/* 导航栏logo */
#header .header-nav .header-nav-logo {
  width: 200px;
  height: 100%;
  float: left;
  position: relative;
}
/* 导航栏logo图片 */
#header .header-nav .header-nav-logo img {
  /*width: 95px;*/
  max-width: 100%;
  //min-height: 55px;
  position: absolute;
  top: -5px;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}
/* 导航栏 导航容器 */
#header .header-nav-fixed .header-nav-wrapper {
  line-height: 50px;
}
#header .header-nav-fixed .header-nav-wrapper-right {
  line-height: 50px;
}
#header .header-nav .header-nav-wrapper {
  line-height: 90px;
  /*float: right;*/
  margin: 0;
  /*max-width: 800px;*/
}
#header .header-nav .header-nav-wrapper-right {
  line-height: 20px;
  float: right;
  display: flex;
  justify-content: flex-end;
  margin: 25px 0;
  padding: 10px;
  background: rgba(0,0,0,0.25);
  border-radius: 5px;
  color: #FFF;
  /*max-width: 00px;*/
}
#header .header-nav .header-nav-wrapper-right .wximg {
   height: 20px;
   margin-left: 20px;
}
#header .header-nav .header-nav-wrapper-right .wxcontent {
  position: absolute;
  margin-top: 30px;
  height: 200px;
  width: 200px;
  z-index: 99999;
  background-image: url("../assets/img/header/content.png");
  background-size: 100% 100%;
  display: none;
  transition: height 1s;
  -webkit-transition: height 1s;
}
#header .wxcontent-m {

  height: 200px;
  width: 200px;
  z-index: 99999;
  background-image: url("../assets/img/header/content.png");
  background-size: 100% 100%;
  /*display: none;*/
  transition: height 1s;
  -webkit-transition: height 1s;
  margin: auto;
  position: fixed;
  /* top: 50%; */
  right: 0;
}
#header .wxcontent-m img {
  width: 180px;
  height: 170px;
  margin: 20px auto;
}
#header .header-nav .header-nav-wrapper-right .wxcontent img {
  width: 180px;
  height: 180px;
  margin: 20px 10px;
  transition: height 1s;
  -webkit-transition: height 1s;
}
.wxtop-m:hover + .wxcontent-m{
  display: block;
}
#header .header-nav .header-nav-wrapper-right .wximg:hover + .wxcontent {
  height: 200px;
  display: block;
}
#header .header-nav .header-nav-wrapper-right .wximg:hover + .wxcontent img {
  height: 180px;
  /*display: block;*/
}
/* 导航栏 每个导航 */
#header .header-nav .header-nav-wrapper > li {
  float: left;
  margin: 0 15px;
  position: relative;
}
/* 导航栏 每个导航下面的 a 链接 */
#header .header-nav .header-nav-wrapper > li > a {
  color: #FFFFFF;
  font-size: 16px;
  /*font-weight: bold;*/
  padding: 5px 10px;
  position: relative;
  border-radius: 20px;
}

/* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover {

  text-decoration: none;
  background: #a82d29 ;
}

/* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
#header .header-nav .header-nav-wrapper > li.active > a {
  /*color: #1e73be;*/
  text-decoration: none;
  background: #a82d29 ;
  border-radius: 18px;
}
@media screen and (min-width: 1200px){
  #header .header-nav{
    width: 98%;
  }
}
@media screen and (min-width: 996px) and (max-width: 1200px){
  #header .header-nav .header-nav-logo {
    width: 160px
  }
  #header .header-nav .header-nav-wrapper > li > a {
    padding: 5px;
    font-size: 15px;
  }
}
@media screen and (min-width: 768px) and (max-width: 996px){
  #header .header-nav{
    width: 100%;
    padding: 0 5px;
  }
  #header .header-nav .header-nav-wrapper > li {
    margin: 0 5px
  }
  #header .header-nav .header-nav-logo {
    width: 110px;
  }
  /* 导航栏logo图片 */
  #header .header-nav .header-nav-logo img {

    max-width: 100%;
    //min-height: 42px;
  }
  #header .header-nav .header-nav-wrapper > li > a {
    padding: 5px;
    font-size: 14px;
  }
}
@media screen and (min-width: 768px){
  #header .header-nav{
    width: 100%;
  }
}
@media screen and (max-width: 997px) {

  #header {
    background: rgba(0,0,0,0.15);
    position: fixed;
  }
  #header .header-nav-m {
    position: relative;
  }
  /* 导航栏logo容器 */
  #header .header-nav-m .header-nav-m-logo {
    height: 80px;
    position: relative;
  }
  /* 导航栏logo图片 */
  #header .header-nav-m .header-nav-m-logo img {
    width: 95px;
    height: 45px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
  }
  /* 导航栏  菜单容器 */
  #header .header-nav-m .header-nav-m-menu {
    color: #fff;
    height: 50px;
    font-size: 20px;
    line-height: 50px;
    /*background: #474747;*/
    position: relative;
  }
  /* 导航栏 菜单图标 */
  #header .header-nav-m .header-nav-m-menu-wrapper {
    position: absolute;
    top: 50%;
    /*right: 20px;*/
    margin-top: -25px;
    width: 40px;
    height: 40px;
    color: #fff;
    z-index: 999999;
    font-size: 12px;
  }
  /* 导航栏 */
  #header .header-nav-m .header-nav-m-wrapper {
    position: absolute;
    top: 50px;
    left: 0;
    width: 100%;
    background: rgba(0,0,0,0.8);
    z-index: 9999999;
    /*height: calc(100vh);*/
  }
  /* 导航栏 每个导航 */
  #header .header-nav-m .header-nav-m-wrapper > li {
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #ccc;
  }
  /* 导航栏 每个导航下面的 a 链接 */
  #header .header-nav-m .header-nav-m-wrapper > li > a {
    color: #fff;
    font-size: 15px;
    /*font-weight: bold;*/
    padding: 15px 0;
    position: relative;
  }
  /* 导航栏 每个导航下面的 a 链接的右侧小三角 */
  #header .header-nav .header-nav-wrapper > li > a > span {
    font-size: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue